"use client";

import { useRouter } from "@/i18n/navigation";
import { getLocalRedirectPath, toLocalPath } from "@/lib/auth/login-redirect";
import { useSearchParams } from "next/navigation";

interface UseLoginRedirectOptions {
    redirectTo?: string | null;
}

export function useLoginRedirect({
    redirectTo = null,
}: UseLoginRedirectOptions = {}) {
    const router = useRouter();
    const searchParams = useSearchParams();

    const handleEmailNotVerified = (username: string) => {
        router.push(
            `/send-new-registration-link?username=${encodeURIComponent(username)}`,
        );
    };

    const handleSuccess = () => {
        const from = searchParams.get("from");
        router.push(getLocalRedirectPath(from) ?? toLocalPath(redirectTo));
    };

    return {
        handleEmailNotVerified,
        handleSuccess,
    };
}
